export async function readResponseJson(response: Response): Promise<{
  data: unknown
  parseError: unknown | null
}> {
  try {
    return { data: await response.json(), parseError: null }
  } catch (error) {
    return { data: undefined, parseError: error }
  }
}

export function getResponseDebugContext(response: Response, requestUrl: string) {
  return {
    requestUrl,
    responseUrl: response.url,
    responseRedirected: response.redirected,
    responseStatus: response.status,
    responseStatusText: response.statusText,
    responseContentType: response.headers.get('content-type'),
    responseContentLength: response.headers.get('content-length'),
  }
}

export function getTopLevelKeys(data: unknown): string[] | null {
  return data && typeof data === 'object' && !Array.isArray(data) ? Object.keys(data) : null
}

export function formatUnknownError(error: unknown): string {
  return error instanceof Error ? error.message : String(error)
}
